import React from 'react';
import Dashboard from './components/Dashboard';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Dashboard data-id="element-1" />
    </div>;
}